import useSetChartExport from '@components/export/useSetChartExport';
import React from 'react';
import { useCompareData } from '../hooks/useCompareSeries';
import { getFilterName } from '@src/utils/filter/utils';
import { DATA_TAGS } from '../hooks/useData';

function ExportCompareFilters() {
  const { data, compareFilters, totals } = useCompareData({ dataTag: DATA_TAGS.compare });
  return compareFilters.map((filter, idx) => (
    <ExportTs
      data={data[idx]}
      totals={totals[idx]}
      filter={filter}
      idx={idx}
      key={`${filter.name}-${idx}`}
    />
  ));
}

function ExportTs({ totals, data, filter, idx }) {
  const widgetKey = `compare-series-${idx}`;

  useSetChartExport({
    pageKey: 'trends',
    sectionKey: 'compare-panel',
    widgetKey,
    widgetInfo: {
      title: `Timeseries for ${getFilterName(filter)}`,
    },
    data,
    totals,
  });

  return <React.Fragment key={widgetKey} />;
}

export default ExportCompareFilters;
